export default {"src":"/_next/static/media/crossWithPaw_40.2d989322.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};